import React from "react";

import FooterBanner from "./FooterBanner";

const Footer: React.FC = () => {
  return (
    <div>
      <div className="container mb-10">
        <FooterBanner />
      </div>
    </div>
  );
};

export default Footer;
